"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmptySearchResults;

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _noResults = _interopRequireDefault(require("bender-url!FileManagerImages/images/no-results.svg"));

function EmptySearchResults() {
  return _react.default.createElement("div", {
    className: "text-center"
  }, _react.default.createElement(_UIImage.default, {
    className: "m-y-10",
    width: 100,
    src: _noResults.default,
    responsive: false
  }), _react.default.createElement("h5", null, _I18n.default.text('FileManagerLib.noResults.message')));
}

module.exports = exports.default;